(function (){
    'use strict';

    angular
        .module('generalReports', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'validation',
            'angular.morris',
            '720kb.tooltips'
        ]);
})();